import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full h-[420px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20anime%20style%20manga%20reading%20scene%20with%20floating%20comic%20pages%20and%20colorful%20action%20effects%2C%20warm%20orange%20and%20pink%20gradient%20atmosphere%2C%20Japanese%20manga%20aesthetic%20with%20speed%20lines%20and%20ink%20splash%20effects%2C%20energetic%20and%20dynamic%20composition%20with%20abstract%20geometric%20shapes&width=1800&height=900&seq=hero-bg-douman&orientation=landscape"
          alt="抖漫网页版 - 在线漫画免费阅读平台"
          className="w-full h-full object-cover object-top"
          title="抖漫网页版在线漫画阅读"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/20 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-3 leading-tight" style={{ fontFamily: 'var(--font-heading)' }}>
            抖漫网页版 - 在线漫画免费阅读平台
          </h1>
          <p className="text-sm md:text-lg text-white/80 mb-8 max-w-xl mx-auto leading-relaxed">
            无需下载APP，海量漫画在线畅读。PC端、手机浏览器直接访问，随时随地免费看漫画
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/rexue"
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-background-50 rounded-full font-semibold text-sm hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line text-lg"></i>
              {t('home.hero_cta')}
            </Link>
            <Link
              to="/category/rexue"
              className="inline-flex items-center gap-2 px-8 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full font-semibold text-sm border border-white/30 hover:bg-white/30 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-grid-line"></i>
              {t('home.hero_secondary')}
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}